import type { RiskCriteria } from "@/mocks/configuracoes";

interface RiskCriteriaTableProps {
  criteria: RiskCriteria[];
}

const classColors: Record<string, string> = {
  "baixo": "bg-primary-50 text-primary-700",
  "médio": "bg-caution-50 text-caution-700",
  "alto": "bg-warning-50 text-warning-700",
  "crítico": "bg-danger-50 text-danger-700",
};

export default function RiskCriteriaTable({ criteria }: RiskCriteriaTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-background-200">
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Critério</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Peso</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Classe sugerida</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Categoria</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Ativo</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Ações</th>
          </tr>
        </thead>
        <tbody>
          {criteria.map((c) => (
            <tr key={c.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
              <td className="py-2.5 px-3 text-foreground-900">{c.name}</td>
              <td className="py-2.5 px-3">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-foreground-100 text-foreground-700 text-xs font-bold">{c.weight}</span>
              </td>
              <td className="py-2.5 px-3">
                <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${classColors[c.suggestedClass] || "bg-foreground-100 text-foreground-600"}`}>
                  {c.suggestedClass}
                </span>
              </td>
              <td className="py-2.5 px-3 text-foreground-600 text-xs">{c.category}</td>
              <td className="py-2.5 px-3">
                <span className={`inline-flex w-2.5 h-2.5 rounded-full ${c.active ? "bg-primary-500" : "bg-foreground-300"}`} />
              </td>
              <td className="py-2.5 px-3">
                <button className="w-8 h-8 rounded-lg hover:bg-background-100 flex items-center justify-center text-foreground-400 hover:text-primary-600 transition-colors" title="Editar">
                  <i className="ri-edit-line text-sm" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}